var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgError = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 60,
  height: 60,
  viewBox: "0 0 60 60"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#D50000",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M30 58c15.464 0 28-12.536 28-28S45.464 2 30 2 2 14.536 2 30s12.536 28 28 28m0 2C13.431 60 0 46.569 0 30S13.431 0 30 0s30 13.431 30 30-13.431 30-30 30"
}), /*#__PURE__*/React.createElement("path", {
  d: "m31.414 29.79 9.044-9.044a1 1 0 0 0-1.414-1.414L30 28.376l-9.044-9.044a1 1 0 0 0-1.414 1.414l9.044 9.044-9.044 9.045a1 1 0 0 0 1.414 1.414L30 31.205l9.044 9.044a1 1 0 0 0 1.414-1.414z"
}))));
export default SvgError;